// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"378":"site","604":"company","884":"admin"}[chunkId] || chunkId) + "." + {"369":"463a4c1c","378":"7646ecf6","483":"99a065e2","604":"81800e94","884":"a8844ded"}[chunkId] + ".js";
};